'use client';

import Script from 'next/script';
import { useLocale } from 'next-intl';
import HotjarScript from './HotjarScript';
import { useBookProStore } from '@/store/useLocaleBookProStore';

export default function TrackingScripts() {
  const isProd = process.env.NEXT_PUBLIC_ENABLE_TRACKING === 'true';
  const email = useBookProStore((state) => state.email);
  const locale = useLocale();

  // Check if this is a UK locale that requires consent
  const requiresConsent = locale === 'en-uk';

  // Prepare advanced matching data - Meta will hash automatically using SHA-256
  const advancedMatchingData = email
    ? { em: email.toLowerCase().trim() }
    : {};

  return (
    <>
      {/* Hotjar Tracking - Always enabled */}
      <HotjarScript />

      {/* Other tracking scripts - Only in production */}
      {isProd && (
        <>
          {/*
            For UK locale: Set default consent to denied BEFORE loading gtag
            This is required for Google Consent Mode v2 compliance
          */}
          {requiresConsent && (
            <Script id="gtag-consent-default" strategy="beforeInteractive">
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('consent', 'default', {
                  'ad_storage': 'denied',
                  'ad_user_data': 'denied',
                  'ad_personalization': 'denied',
                  'analytics_storage': 'denied',
                  'functionality_storage': 'granted',
                  'personalization_storage': 'denied',
                  'security_storage': 'granted'
                });
              `}
            </Script>
          )}

          {/* Google Ads Global Site Tag */}
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=AW-17052233866"
            strategy="afterInteractive"
          />
          <Script id="gtag-init" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-17052233866');
            `}
          </Script>

          {/* Meta Pixel Code */}
          <Script id="fb-pixel" strategy="afterInteractive">
            {`
              !function(f,b,e,v,n,t,s){
                if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)
              }(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');

              // Initialize pixel with advanced matching enabled
              // Email will be hashed automatically by Meta using SHA-256
              fbq('init', '3869861463236325', ${JSON.stringify(advancedMatchingData)}, {
                agent: 'nextjs'
              });

              // Track initial page view
              fbq('track', 'PageView');
            `}
          </Script>
          <noscript
            dangerouslySetInnerHTML={{
              __html: `<img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=3869861463236325&ev=PageView&noscript=1"
                alt=""
              />`
            }}
          />
        </>
      )}
    </>
  );
}